import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font: 400 .875rem 'Open Sans', sans-serif;
    color: rgba(0,0,0,.8);
    overflow-x: hidden;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
  }

  .margin-content {
    margin: 1rem 0;
  }

  .fullwidth {
    width: 100%;
  }

  .editor-hide {
    opacity: 0;
  }

  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
`;
